module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/180.2909fd49.png";